import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';

export interface IGetTrackRevenueTeamSale {
  skip: number;
  take: number;
  year: number;
  fromMonth: number;
  toMonth: number;
  plantId?: string;
  teamSalesId?: string;
  typeRevenue?: string;
  export?: { headerRow: ColumnsTypeCustom };
}

export interface IGetTrackRevenueTeamSalesDetail {
  plantId?: string;
  year: number;
  teamSalesId?: string;
}

export const CNPLAN_VARIABLE = {
  getListCNPlan: (params: any) => {
    const { page, page_size, input } = params;

    return {
      take: page_size,
      skip: (page - 1) * page_size,
      input: {
        ...input,
        approvalYn: { equals: true },
      },
    };
  },
  createCNPlan: (data: any) => {
    return { input: data };
  },
  updateHOPlan: (data: any) => {
    return { input: data };
  },
  importCNPlan: (data: any) => {
    return { input: data };
  },
  Check_Revenue_Plan_TeamSale_is_exist_VARIABLE: (data: any) => {
    return {
      input: {
        AND: [
          {
            plantId: { equals: data.plantId },
          },
          {
            teamSaleId: { equals: data.teamSaleId },
          },
          {
            year: {
              equals: data.year,
            },
          },
        ],
      },
    };
  },
  getRevenueTeamsaleOfUser: (input: any) => {
    const { page, page_size, ...others } = input;

    return {
      take: page_size,
      skip: (page - 1) * page_size,
      ...others,
    };
  },
  GET_REVENUE_TEAMSALE_BY_PLANTID_YEAR_Variable: (data: any) => {
    return {
      input: {
        AND: [
          {
            plantId: { equals: data.plantId },
          },
          {
            year: { equals: data.year },
          },
        ],
      },
    };
  },
  GetTypeRevenueComBoBox: (data: any) => {
    return {
      input: {
        groupId: { equals: data },
      },
    };
  },
  CheckExistedRevenueTeamSale: (data: any) => {
    return {
      input: {
        plantId: { equals: data.plantId },
        teamSalesId: { equals: data.teamSalesId },
        year: { equals: data.year },
        typeRevenue: { equals: data.typeRevenue },
      },
    };
  },
  // get Track Revenue Team sales
  getTrackRevenueTeamSale: ({
    skip,
    take,
    fromMonth,
    toMonth,
    plantId,
    teamSalesId,
    typeRevenue,
    year,
  }: IGetTrackRevenueTeamSale) => {
    return {
      skip,
      take,
      input: {
        year,
        fromMonth,
        toMonth,
        ...(plantId && { plantId }),
        ...(teamSalesId && { teamSalesId }),
        ...(typeRevenue && { typeRevenue }),
      },
    };
  },
  // get Track Revenue TeamSales Detail
  getTrackRevenueTeamSalesDetail: ({
    year,
    plantId,
    teamSalesId,
  }: IGetTrackRevenueTeamSalesDetail) => {
    return {
      input: {
        year,
        ...(plantId && { plantId }),
        ...(teamSalesId && { teamSalesId }),
      },
    };
  },
};
